/*@ngInject*/
module.exports = function(publicUsersService, $uibModal) {
    return {
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
            const vm = this;
            vm.bookmarks = [];
            vm.publishedBookmarkedObjectsData = [];
            vm.selectedObject = {};
            vm.objectMapModalOpen = false;
            vm.isMapView = false;

            vm.$onInit = function () {
                publicUsersService.getBookmarks().then(function (result) {
                    vm.bookmarks = result.data;
                    vm.objectGisIds = _.map(_.filter(vm.bookmarks.objects, b => b.objectData.status === 'PUBLISHED'), b => b.objectData.gis_id);
                    vm.routeGisIds = _.map(_.filter(vm.bookmarks.routes, b => b.routeData.status === 'PUBLISHED'), b => b.routeData.gis_id);
                });
            };

            vm.updateRouteBookmark = function (updateBookmark) {
                publicUsersService.updateBookmark(updateBookmark.object_type, updateBookmark.object_id).then(function (result) {
                    vm.bookmarks.routes = _.filter(vm.bookmarks.routes, bookmark => bookmark.object_id !== updateBookmark.object_id);
                });
            };

            vm.updateObjectBookmark = function(updateBookmark) {
                publicUsersService.updateBookmark(updateBookmark.object_type, updateBookmark.object_id).then(function (result) {
                    vm.bookmarks.objects = _.filter(vm.bookmarks.objects, bookmark => bookmark.object_id !== updateBookmark.object_id);
                });
            };

            vm.showOnMap = function (object) {
                $uibModal.open({
                    template: require('../object-map-modal.directive.html'),
                    controller: require('../object-map-modal.directive'),
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'center-modal',
                    resolve: {
                        data () {
                            return object ;
                        }
                    }
                });
            };
        },
        template: require('./current-user-bookmarks.directive.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/bookmarks/current-user-bookmarks.directive.js
 **/